import { render } from "./customerTagEdit.vue?vue&type=template&id=a8ed0728&scoped=true"
import script from "./customerTagEdit.vue?vue&type=script&lang=js"
export * from "./customerTagEdit.vue?vue&type=script&lang=js"

import "./customerTagEdit.vue?vue&type=style&index=0&id=a8ed0728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ed0728"]])

export default __exports__